import { startCase, camelCase } from 'lodash'

export default function titleCase(str) {
  return startCase(camelCase(str))
}